import { DEVICE_ID, SORT_DESC } from 'constants';
import Cookies from 'helpers/cookies';
import { isImageType, resize } from 'helpers/image';
import { stringUtils } from 'utils';
import { mockAbortSignalERRCANCELED, mockHTTPCode } from './func';

export default (axios) => ({
  /* Remit */
  getCountries() {
    return axios.get(`/public/remit/countries`);
  },
  getCurrencies(countryCode, dmCode) {
    return axios.get(`/public/remit/currencies/${countryCode}/${dmCode}`);
  },
  getCurrenciesSupportedByCountry(countryCode) {
    return axios.get(`public/remit/currencies/${countryCode}`);
  },
  getDeliveryMethods(countryCode) {
    return axios.get(`/public/remit/delivery-methods/${countryCode}`);
  },
  getPickupOffices(countryCode) {
    return axios.get(`/public/remit/pickup-offices/${countryCode}`);
  },
  getBranches() {
    return axios.get(`/public/remit/branches`);
  },
  getBanks(countryCode) {
    return axios.get(`/public/remit/banks/${countryCode}`);
  },
  lookupRate(countryCode, dmCode, currencyCode) {
    return axios.post(`/public/remit/rates/lookup`, {
      countryCode,
      dmCode,
      currencyCode,
    });
  },
  lookupWwRate(currencyCode) {
    return axios.get(`/public/remit/rates/worldwide/${currencyCode}`);
  },
  lookupFee(countryCode, dmCode, amount, currencyCode, pickupOfficeId) {
    return axios.post(`/public/remit/fees/lookup`, {
      amount,
      countryCode,
      currencyCode,
      dmCode,
      pickupOfficeId,
    });
  },
  lookupOriginalFee(countryCode, dmCode, amount, currencyCode, pickupOfficeId) {
    return axios.post(`/public/remit/fees/lookup-original`, {
      amount,
      countryCode,
      currencyCode,
      dmCode,
      pickupOfficeId,
    });
  },
  ifsc(bankCode) {
    return axios.get(`/public/remit/ifsc/${bankCode}`);
  },
  getEwallets(countryCode) {
    return axios.get(`/public/remit/ewallets/${countryCode}`); // modified to countryCode
  },
  remitRounding(token, remitPayload, options = {}) {
    // remitPayload = {
    //   sendingAmount: '20.00',
    //   receivingAmount: '20',
    //   rate: 1,
    //   currencyCode: 'AUD',
    //   dmCode: 'HOME',
    //   countryCode: 'VNM',
    //   pickupOfficeId: '',
    // };
    // return mockHTTPCode(500);
    return axios.post(`/remit/quote`, remitPayload, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  remitRoundingPublic(remitPayload) {
    // remitPayload = {
    //   sendingAmount: '20.00',
    //   receivingAmount: '20',
    //   rate: 1,
    //   currencyCode: 'AUD',
    //   dmCode: 'HOME',
    //   countryCode: 'VNM',
    //   pickupOfficeId: '',
    // };
    return axios.post(`/public/remit/quote`, remitPayload);
  },

  /* Configs */
  getCountryConfig(countryCode) {
    return axios.get(`/public/config/${countryCode}`);
  },
  getAppUUID() {
    return axios.get(`/public/config/app-uuid`);
  },
  lookupSp(countryCode, dmCode, currencyCode) {
    return axios.post(`/public/config/sp-lookup`, {
      countryCode,
      dmCode,
      currencyCode,
    });
  },
  getConfigOccupation(locate) {
    return axios.get(`/public/config/occupation`, {
      headers: { lang: locate },
    });
  },
  getConfigRelationship(locate, path) {
    return axios.get(`/public/config/relationship${path || ''}`, {
      headers: { lang: locate },
    });
  },
  getConfigPurpose(locate, path) {
    return axios.get(`/public/config/purpose${path || ''}`, {
      headers: { lang: locate },
    });
  },
  getConfigSourcesOfWealth(locate) {
    return axios.get(`/public/config/sources-of-wealth`, {
      headers: { lang: locate },
    });
  },
  /* Location */
  getCities(countryCode) {
    return axios.get(`/public/remit/cities/${countryCode}`);
  },
  getSuburbs(cityId) {
    return axios.get(`/public/remit/suburbs/${cityId}`);
  },
  /* Tran */
  getTrans(token, page = 1, size = 10) {
    return axios.get(`/trans?page=${page - 1}&size=${size}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  searchTrans(token, body = {}, sort = {}, page = 1, size = 10) {
    const sortPayload = {
      sortField: sort?.sortField || 'createDate',
      sortOrder: sort?.sortOrder || SORT_DESC,
      ...sort,
    };
    const bodyPayload = body;

    return axios.patch(
      `/trans?page=${page - 1}&size=${size}&sortField=${
        sortPayload.sortField
      }&sortOrder=${sortPayload.sortOrder}`,
      bodyPayload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
  },
  getRecentTrans(token, size = 10) {
    return axios.get(`/trans/recent?size=${size}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  getTran(token, refNumber) {
    return axios.get(`/trans/${refNumber}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  getEditableTran(refNumber) {
    return axios.get(`/trans/editable/${refNumber}`);
  },
  createTran(token, tran) {
    return axios.post(`/trans`, tran, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      // signal: mockAbortSignalERRCANCELED(600),
    });
  },
  updateTran(token, refNumber, tran) {
    return axios.put(`/trans/${refNumber}`, tran, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  getTransCountries(token) {
    return axios.get(`/trans/countries`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  /* Payment */
  // Poli
  getPoliBanks() {
    return axios.get(`/payments/poli/banks`);
  },
  payPoli(token, refNumber, successPath, failPath) {
    const homeUrl = `${window.location.protocol}//${window.location.hostname}:${window.location.port}`;

    return axios.post(
      `/payments/poli/${refNumber}`,
      {
        homeUrl,
        successPath,
        failPath,
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
  },
  getPoliTran(token) {
    return axios.get(`/payments/poli/${token}`);
  },
  // Wirecard
  payWirecard(refNumber, homeUrl) {
    const successPath = 'tran-success';
    const failPath = 'tran';
    return axios.post(`/payments/wirecard/${refNumber}`, {
      homeUrl,
      successPath,
      failPath,
    });
  },
  // Mint payment
  payMint(
    token,
    refNumber,
    number,
    expiryMonth,
    expiryYear,
    cvc,
    holderName,
    savedForFuture,
  ) {
    return axios.post(
      `/payments/mint/${refNumber}`,
      {
        number,
        expiryMonth,
        expiryYear,
        cvc,
        holderName,
        savedForFuture,
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
  },
  processMint(token, refNumber, tokenTransaction) {
    return axios.post(
      `/payments/mint/process`,
      { refNumber, token: tokenTransaction },
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
  },
  // I Have Paid - DELETE
  ihavepaid(token, refNumber) {
    return axios.get(`/payments/ihavepaid/${refNumber}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  // Bsb / PayId validation
  validateBsbAccount(token, bsb, accountNumber) {
    return axios.post(
      `/payments/validate/account`,
      {
        bsb,
        accountNumber,
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
  },
  validatePayId(token, payId, payIdType, senderId = 0) {
    return axios.post(
      `/payments/validate/payid`,
      {
        payId,
        payIdType,
        senderId,
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
  },
  // Payto
  getPaytoBankAccountsVerified(token) {
    return axios.get(`/profile/verified-bank-account`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  getPaytoAccountsAgreement(token) {
    // "paymentAgreementUID": "EAPAYTODWY75E5RJQP1LO0M1759212580",
    // "paymentAgreementStatus": "Created",
    // "accountNumber": "*********100",
    // "bsb": "802950",
    // "bankCode": null,
    // "bankName": null,
    // "maxAmount": 6000.0,
    // "responseBy": "10/05/2025 16:09:40",
    // "pendingAmend": false,
    // "blocked": false
    return axios.get(`/payments/payto`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  addPaytoAccountAgreement(token, payload) {
    // "paymentAgreementUID": "EAPAYTODWY75E5RJQP1LO0M1759212580",
    // "paymentAgreementStatus": "Created",
    // "accountNumber": "*********100",
    // "bsb": "802950",
    // "bankCode": null,
    // "bankName": null,
    // "maxAmount": 6000,
    // "responseBy": "10/05/2025 16:09:40",
    // "pendingAmend": false,
    // "blocked": false
    return axios.post(`/payments/payto`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  checkStatusPaytoAccountAgreementById(token, paymentAgreementUID) {
    // "paymentAgreementUID": "EAPAYTODWY75E5RJQP1LO0M1759212580",
    // "paymentAgreementStatus": "Active",
    // "accountNumber": "*********100",
    // "bsb": "802950",
    // "bankCode": null,
    // "bankName": null,
    // "maxAmount": 2000,
    // "responseBy": "10/05/2025 16:09:40",
    // "pendingAmend": false,
    // "blocked": true
    return axios.get(`/payments/payto/${paymentAgreementUID}/status`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  updatePaytoAccountAgreementById(token, accountAgreement) {
    const { paymentAgreementUID, maxAmount } = accountAgreement || {};
    // "paymentAgreementUID": "EAPAYTODWY75E5RJQP1LO0M1759212580",
    // "paymentAgreementStatus": "Cancelled",
    // "accountNumber": "*********100",
    // "bsb": "802950",
    // "bankCode": null,
    // "bankName": null,
    // "maxAmount": 2000,
    // "responseBy": "10/05/2025 16:09:40",
    // "pendingAmend": false,
    // "blocked": false

    const payload = {
      userId: 0,
      userType: 'CUSTOMER',
      maxAmount,
    };
    return axios.put(`/payments/payto/${paymentAgreementUID}`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  deletePaytoAccountAgreementById(token, paymentAgreementUID) {
    // "paymentAgreementUID": "EAPAYTODWY75E5RJQP1LO0M1759212580",
    // "paymentAgreementStatus": "Cancelled",
    // "accountNumber": "*********100",
    // "bsb": "802950",
    // "bankCode": null,
    // "bankName": null,
    // "maxAmount": 2000,
    // "responseBy": "10/05/2025 16:09:40",
    // "pendingAmend": false,
    // "blocked": false
    return axios.delete(`/payments/payto/${paymentAgreementUID}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  checkReceiverVerifiedByOTP(token, receiverId, isResendViaEmail) {
    return axios.get(
      `/receivers/${receiverId}/verify${
        isResendViaEmail ? '?channel=EMAIL' : ''
      }`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
  },

  /* Receiver */
  getAllReceivers(token) {
    return axios.get(`/receivers/all`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  getReceivers(token, page = 1, size = 10) {
    return axios.get(`/receivers?page=${page - 1}&size=${size}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  searchReceivers(token, body = {}, sort = {}, page = 1, size = 10) {
    const sortPayload = {
      sortField: sort?.sortField || 'createDate',
      sortOrder: sort?.sortOrder || SORT_DESC,
      ...sort,
    };
    const bodyPayload = body;

    return axios.patch(
      `/receivers?page=${page - 1}&size=${size}&sortField=${
        sortPayload.sortField
      }&sortOrder=${sortPayload.sortOrder}`,
      bodyPayload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
  },
  getReceiversCountries(token, path = '') {
    return axios.get(`/receivers/countries${path || ''}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  getFavReceivers(token, page = 1, size = 10) {
    return axios.get(`/receivers/favorited?page=${page - 1}&size=${size}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  getReceiver(token, id) {
    return axios.get(`/receivers/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  createReceiver(token, receiver) {
    return axios.post(`/receivers`, receiver, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  updateDetails(token, id, details) {
    return axios.put(`/receivers/${id}`, details, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  deleteReceiver(token, id) {
    return axios.delete(`/receivers/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  /* Receiver - Record */
  getReceiverRecord(token, refNumber) {
    return axios.get(`/receivers/record/${refNumber}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  /* Receiver - Contact */
  addContact(token, id, type, contact) {
    return axios.post(`/receivers/${id}/contact/${type}`, contact, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  updateContact(token, id, contactId, contact) {
    return axios.put(`/receivers/${id}/contact/${contactId}`, contact, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  deleteContact(token, id, contactId) {
    return axios.delete(`/receivers/${id}/contact/${contactId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  /* Receiver - Address */
  updateAddress(token, id, addressId, address) {
    return axios.put(`/receivers/${id}/address/${addressId}`, address, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  /* Receiver - Bank */
  addBank(token, id, bank) {
    return axios.post(`/receivers/${id}/bank`, bank, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  updateBank(token, id, bankId, bank) {
    return axios.put(`/receivers/${id}/bank/${bankId}`, bank, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  deleteBank(token, id, bankId) {
    return axios.delete(`/receivers/${id}/bank/${bankId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  /* Receiver - pref */
  setFavorited(token, id, favorited) {
    return axios.get(`/receivers/${id}/fav/${favorited}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  /* Receiver - relationship */
  updateRelationship(token, id, relationship) {
    return axios.post(
      `/receivers/${id}/relationship`,
      { relationship },
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
  },
  /* Receiver - Ewallet */
  addEwallet(token, id, ewallet) {
    return axios.post(`/receivers/${id}/ewallet`, ewallet, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  updateEwallet(token, id, receiverEwalletId, ewallet) {
    return axios.put(`/receivers/${id}/ewallet/${receiverEwalletId}`, ewallet, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  deleteEwallet(token, id, receiverEwalletId) {
    return axios.delete(`/receivers/${id}/ewallet/${receiverEwalletId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  /* Receiver - Verification */
  addReceiverVerification(id, verification) {
    return axios.post(`/receivers/${id}/verification`, verification);
  },
  updateReceiverVerification(id, receiverVerificationId, verification) {
    return axios.put(
      `/receivers/${id}/verification/${receiverVerificationId}`,
      verification,
    );
  },
  getReceiverVerification(type, entityId) {
    return axios.get(
      `/receivers/verification?type=${type}&entityId=${entityId}`,
    );
  },

  /* Profile */
  getProfile(token) {
    return axios.get(`/profile`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  updateProfile(token, profile) {
    return axios.put(`/profile`, profile, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  updatePassword(token, currentPassword, newPassword) {
    return axios.put(
      `/profile/password`,
      { currentPassword, newPassword },
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
  },
  getOptin(token) {
    return axios.get(`/profile/optin`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  saveOptin(token, type, optin) {
    return axios.get(`/profile/optin/${type}/${optin}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  getRiskLevel() {
    return axios.get(`/profile/risk-level`);
  },
  getOccupation(token) {
    return axios.get(`/profile/occupation`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  saveOccupation(token, occupation) {
    return axios.put(`/profile/occupation`, occupation, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  getBirthCountry(token) {
    return axios.get(`/profile/cob`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  saveBirthCountry(birthCountry) {
    return axios.put(`/profile/cob`, birthCountry);
  },
  saveDeviceToken(token, deviceToken, language, active) {
    return axios.post(
      `/profile/device-tokens`,
      {
        token: deviceToken,
        language,
        active,
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
  },

  /* Signup */
  getSignup(signupId) {
    return axios.get(`/public/signups/${signupId}`);
  },
  saveSignup(signup) {
    return axios.post(`/public/signups`, signup);
  },
  saveSignupV2(signup) {
    return axios.post(`/public/v2/signups`, signup);
  },
  isExistingCustomer(firstName, otherNames, lastName, gender, dob) {
    const name = otherNames ? `${firstName} ${otherNames}` : firstName;
    return axios.post(`/public/signups/is-existing-customer`, {
      firstName: name,
      lastName,
      gender,
      dob,
    });
  },
  isUsernameValid(username) {
    return axios.post(`/public/signups/is-username-valid`, { username });
  },
  async uploadDocument(docType, file, fileName) {
    let fileUpload = file;
    if (isImageType(file)) {
      fileUpload = await resize(file);
    }
    const formData = new FormData();
    formData.append('docType', docType);
    formData.append('file', fileUpload, fileName);
    return axios.post(`/public/signups/upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  async fxUploadDocument(docType, idType, file) {
    let fileUpload = file;
    if (isImageType(file)) {
      fileUpload = await resize(file);
    }
    const formData = new FormData();
    formData.append('docType', docType);
    formData.append('idType', idType);
    formData.append('file', fileUpload);
    return axios.post(`/public/fx/documents/upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  /* Discount */
  applyDiscount({
    token,
    code,
    countryCode,
    currencies,
    deliveryMethod,
    paymentMethod,
    receivingAmount,
    txnAmount,
    txnFee,
    serviceType = 'TO',
    cityId,
  }) {
    const payload = {
      code,
      countryCode,
      currencies,
      deliveryMethod,
      paymentMethod,
      receivingAmount,
      txnAmount,
      txnFee,
      serviceType,
      cityId,
    };
    // return mockHTTPCode(400);
    return axios.post(`/discounts`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },
  getDiscountsActive(token) {
    return axios.get(`/profile/discounts/active`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  getAllDiscounts(token) {
    // /profile/discounts
    return axios.get(`/profile/discounts/service-type/all`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  /* Auth */
  login(username, password) {
    return axios.post(
      `/public/login`,
      { username, password },
      {
        withCredentials: true,
        headers: {
          deviceId: Cookies.get(DEVICE_ID),
        },
      },
    );
  },
  activate(token, password) {
    return axios.post(`/public/activate`, { token, password });
  },
  forgotPassword(username) {
    return axios.post(`/public/password/forgot`, { username });
  },
  resetPassword(token, password) {
    return axios.post(`/public/password/reset`, { token, password });
  },
  refreshToken(token) {
    return axios.get(`/auth/refresh`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  logout(token) {
    return axios.post(
      `/public/logout`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );
  },

  /* Validation */
  validatePhone(countryCode, number) {
    const payload = {
      number,
      country_code: countryCode,
    };
    return axios.post(`/public/validation/phone`, payload);
  },
  validateAccNumber(countryCode, bankId, bankAccNumber, rFirstName, rLastName) {
    return axios.post(`/public/validation/bank-acc`, {
      countryCode,
      bankId,
      bankAccNumber: stringUtils.replaceAllCharacter(bankAccNumber),
      rFirstName: rFirstName || '',
      rLastName: rLastName || '',
    });
  },
  validateIBAN(iban) {
    return axios.get(
      `/public/validation/iban?value=${stringUtils.replaceAllCharacter(iban)}`,
    );
  },
  validateSWIFT(swiftCode) {
    return axios.get(
      `/public/validation/swift?value=${stringUtils.replaceAllCharacter(
        swiftCode,
      )}`,
    );
  },
  validateRoutingNumber(routingNumber) {
    return axios.get(
      `/public/validation/routing-number?value=${stringUtils.replaceAllCharacter(
        routingNumber,
      )}`,
    );
  },
  validateBSB(bsb) {
    return axios.get(
      `/public/validation/bsb?value=${stringUtils.replaceAllCharacter(bsb)}`,
    );
  },
  validateBSBVer2(bsb) {
    // "durationMs": 5,
    // "status": "Ok",
    // "statusDescription": "Operation completed successfully",
    // "address": "Level 11, 201 Sussex Street",
    // "bankCode": "CRU",
    // "bsb": "802-950",
    // "city": "Sydney",
    // "closed": false,
    // "postCode": "2000",
    // "state": "NSW",
    // "bankName": null
    return axios.get(
      `/public/validation/v2/bsb/${stringUtils.replaceAllCharacter(bsb)}`,
    );
  },
  validateSortCode(sortCode) {
    return axios.get(
      `/public/validation/sort-code?value=${stringUtils.replaceAllCharacter(
        sortCode,
      )}`,
    );
  },
  validateEmail(email) {
    return axios.get(`/public/validation/email/${email}`);
  },

  /* Money Gram */
  lookupMGFeeInfo(
    countryCode,
    dmCode,
    currencyCode,
    sendAmount,
    receiveAmount,
  ) {
    return axios.post(`/mg/fee-lookup`, {
      countryCode,
      dmCode,
      currencyCode,
      sendAmount,
      receiveAmount,
    });
  },
  getFieldsForProduct(countryCode, dmCode, currencyCode, sendAmount) {
    return axios.post(`/mg/gffp`, {
      countryCode,
      dmCode,
      currencyCode,
      sendAmount,
    });
  },
  isMg(countryCode, dmCode, currencyCode) {
    return axios.post(`/mg/is-mg`, { countryCode, dmCode, currencyCode });
  },
  sendValidation(tran) {
    return axios.post(`/mg/send-validation`, tran);
  },
  stagTranx(tran) {
    return axios.post(`/mg/stag-tranx`, tran);
  },
  getStateList(countryCode) {
    return axios.get(`/public/remit/mg/states/?countryCode=${countryCode}`);
  },
  getCityList(countryCode, stateCode) {
    return axios.get(
      `/public/remit/mg/cities/?countryCode=${countryCode}&stateCode=${stateCode}`,
    );
  },
  getLocationList(countryCode, stateCode, city) {
    return axios.get(
      `/public/remit/mg/agents/?countryCode=${countryCode}&stateCode=${stateCode}&city=${city}`,
    );
  },

  /* Harmony */
  lookupAddresses(address, transactionID) {
    return axios.get(
      `/public/validation/au-address/v1/lookup?address=${address}&transactionID=${transactionID}`,
    );
  },
  lookupPostcodes(postcode, transactionID) {
    return axios.get(
      `/public/validation/au-address/v1/lookup/postcode?postcode=${postcode}&transactionID=${transactionID}`,
    );
  },
  lookupAddressLocality(
    postcodeOrCityValue,
    transactionID = 'd6fe8ff05352dfff3c3a3367d7140364',
  ) {
    return axios.get(
      `/public/validation/au-address/v1/lookup/locality?locality=${postcodeOrCityValue}&transactionID=${transactionID}`,
    );
  },

  /* i18n-controller */
  getTranslationLocate(locate) {
    return axios.get(`/public/i18n`, {
      headers: { lang: locate },
    });
  },

  /* event-controller */
  getEventsAvailable(token) {
    return axios.get(`/profiles/events`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  addEventRecordData(token, event) {
    return axios.post(`/profiles/events/record`, event, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  getAllEvents(token) {
    return axios.patch(
      `/profiles/events`,
      {},
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
  },
  checkEventEligible(token, eventId, onlineRef) {
    return axios.get(
      `/profiles/events/${eventId}/eligible?onlineRef=${onlineRef}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
  },
  getEventsAvailablePublic() {
    return axios.get(`/public/events`);
  },
  checkEventEligiblePublic(eventId, onlineRef, senderId) {
    return axios.get(
      `/public/events/${eventId}/eligible?onlineRef=${onlineRef}&senderId=${senderId}`,
    );
  },
  getEventsOnSidebar(token) {
    return axios.get(`/ads`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  /* version-controller */
  getBuildVersion() {
    return axios.get(`/public/build-version`);
  },

  /* fx-controller */
  getPickupLocationsViaAusPost(postcode) {
    return axios.get(`/public/fx/pickup-location/auspost/${postcode}`);
  },
  getPickupDates(payload = {}) {
    return axios.post(`/public/fx/pickup-date`, payload);
  },
  getOrder(token, orderRef) {
    return axios.get(`/fx/order/${orderRef}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  getOrderAsGuest(orderRef, email) {
    return axios.get(`/public/fx/order/${orderRef}?email=${email}`);
  },
  createOrder(token, payload) {
    return axios.post(`/fx`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  createOrderAsGuest(payload) {
    return axios.post(`/public/fx`, payload);
  },
  updateOrder(token, payload) {
    return axios.post(`/fx`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  updateOrderAsGuest(payload) {
    return axios.post(`/public/fx`, payload);
  },
  getFxSellRate(currencyCode = '') {
    return axios.get(`/public/fx/rates/${currencyCode}`);
  },
  getFxSellCurrencies() {
    return axios.get(`/public/fx/currencies`);
  },
  getFxPickupLocationBranches() {
    return axios.get(`/public/fx/pickup-location`);
  },

  // FX online Discount
  getFxDiscountsActive({
    token,
    currency,
    receivingAmount,
    txnAmount,
    txnFee,
    paymentMethod,
    deliveryMethod,
  }) {
    const payload = {
      code: '',
      countryCode: '', // currencyOrders[0]
      currencies: [
        currency, // currencyOrders[0]
      ],
      deliveryMethod,
      orgId: 0,
      paymentMethod: [
        paymentMethod, // paymentMethodName
      ],
      sender: {
        dob: '',
        email: '',
        firstName: '',
        lastName: '',
        phone: '',
      },
      receivingAmount,
      senderId: '',
      serviceType: 'FX',
      txnAmount,
      txnFee,
    };
    return axios.post(`/profile/fx/discounts/active`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  getFxDiscountsActiveAsGuest({
    receivingAmount,
    txnAmount,
    txnFee,
    paymentMethod,
    currency,
    deliveryMethod,
  }) {
    const payload = {
      code: '',
      countryCode: '', // currencyOrders[0]
      currencies: [
        currency, // currencyOrders[0]
      ],
      deliveryMethod,
      orgId: 0,
      paymentMethod: [
        paymentMethod, // paymentMethodName
      ],
      sender: {
        dob: '',
        email: '',
        firstName: '',
        lastName: '',
        phone: '',
      },
      receivingAmount,
      senderId: '',
      serviceType: 'FX',
      txnAmount,
      txnFee,
    };
    return axios.post(`/public/fx/discounts`, payload);
  },
  applyFxDiscount({
    discount,
    currentUser,
    receivingAmount,
    txnAmount,
    txnFee,
    currency,
    deliveryMethod,
    paymentMethod,
  }) {
    const { code } = discount || {};
    const { firstName, lastName, mobile, email, dob } = currentUser || {};
    const payload = {
      code,
      countryCode: '',
      currencies: [currency],
      deliveryMethod,
      orgId: 0,
      paymentMethod: [paymentMethod],
      sender: {
        dob: dob ? new Date(dob) : new Date(),
        email,
        firstName,
        lastName,
        phone: mobile,
      },
      receivingAmount,
      senderId: '',
      serviceType: 'FX',
      txnAmount,
      txnFee,
    };
    return axios.post(`/public/fx/discounts/apply`, payload);
  },

  // FX online Mint payment
  fxPayMint(
    token,
    refNumber,
    number,
    expiryMonth,
    expiryYear,
    cvc,
    holderName,
    savedForFuture,
  ) {
    return axios.post(
      `/fx/payments/mint/pay/${refNumber}`,
      {
        number,
        expiryMonth,
        expiryYear,
        cvc,
        holderName,
        savedForFuture,
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
  },
  fxPayMintAsGuest(
    senderId,
    refNumber,
    number,
    expiryMonth,
    expiryYear,
    cvc,
    holderName,
    savedForFuture,
  ) {
    return axios.post(`/public/fx/payments/mint/pay/${senderId}/${refNumber}`, {
      number,
      expiryMonth,
      expiryYear,
      cvc,
      holderName,
      savedForFuture,
    });
  },
  fxProcessMint(refNumber, tokenTransaction) {
    return axios.post(`/public/fx/payments/mint/process`, {
      refNumber,
      token: tokenTransaction,
    });
  },

  /* FX rates */
  getAllFXRates() {
    return axios.get(`/public/fx/rates`);
  },
  searchFXTrans(token, body = {}, sort = {}, page, size) {
    const sortPayload = {
      sortField: sort?.sortField || 'createdDate',
      sortOrder: sort?.sortOrder || SORT_DESC,
      ...sort,
    };
    const bodyPayload = body;
    return axios.patch(
      `/fx?page=${page - 1}&size=${size}&sortField=${
        sortPayload.sortField
      }&sortOrder=${sortPayload.sortOrder}`,
      bodyPayload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
  },

  /* Referral */
  getReferralLink(token) {
    return axios.get(`/profile/referrals`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  getReferralParticipants(token) {
    return axios.get(`/profile/referrals/referees`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  checkValidReferralCode(referralCode) {
    return axios.get(`/public/referrals/${referralCode}/is-valid`);
  },

  /* PII */
  signupPII(token, signupPIIPayload) {
    return axios.post(`/profile/pii`, signupPIIPayload, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  processVerifyOTPCode(token, verifyOTPPayload) {
    return axios.post(`/profile/otp/verify`, verifyOTPPayload, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  /* KYC */
  saveProfileDocs(token, documentUploadResponses = []) {
    return axios.post(`/profile/docs`, documentUploadResponses, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  async uploadProfileDoc(docType, file, fileName, token) {
    let fileUpload = file;
    if (isImageType(file)) {
      fileUpload = await resize(file);
    }
    const formData = new FormData();
    formData.append('docType', docType);
    formData.append('file', fileUpload, fileName);
    return axios.post(`/profile/upload`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      },
    });
  },
});
